import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import LicenseDetail from "../components/license/LicenseDetail";

const LicenseDetailPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="License Details" />

        {/* LicenseDetail */}
        <LicenseDetail />
      </MasterLayout>
    </>
  );
};

export default LicenseDetailPage;
